<ion-app>
  <ion-menu side="start" contentId="content">
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-title class="ion-text-center"><img src="assets/logo.svg" style="padding-top:5px;" width="123" height="43" /></ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>

        <ion-item lines="none" color="primary" class="user">
          <ion-label class="ion-text-nowrap">
            @if (user) {
              <p>
                <fa-icon [icon]="['fal', 'user']" [fixedWidth]="true"></fa-icon><strong>{{user.first_name}} {{user.last_name}}</strong>
              </p>
            }
            @if (connected_account && connected_account.organisation_title) {
              <p>
                <fa-icon [icon]="['fal', 'building']" [fixedWidth]="true"></fa-icon>{{connected_account.organisation_title}}
              </p>
            }
            @if (register) {
              <p>
                <fa-icon [icon]="['fal', 'cash-register']" [fixedWidth]="true"></fa-icon>{{register.title}}
              </p>
            }
            @if (register) {
              <p>
                <fa-icon [icon]="['fal', 'map-marker-alt']" [fixedWidth]="true"></fa-icon>{{register.location.title}}
              </p>
            }
          </ion-label>
        </ion-item>

        <ion-list class="primary-links">

          @if (permissionService.isPermitted('pos-sell')) {
            <ion-item lines="full" routerLink="/secure/sell" routerDirection="root" (click)="menuClose()">
              <ion-label><fa-icon [icon]="['fal', 'cash-register']" size="lg" [fixedWidth]="true"></fa-icon>Sell</ion-label>
            </ion-item>
          }

          @if (permissionService.isPermitted('pos-parked-carts')) {
            <ion-item button="true" lines="full" (click)="goToParkedCarts('/secure/parked-carts')">
              <ion-label><fa-icon [icon]="['fal', 'cart-arrow-down']" size="lg" [fixedWidth]="true"></fa-icon>Parked carts</ion-label>
            </ion-item>
          }

          @if (permissionService.isPermitted('pos-quotes')) {
            <ion-item button="true" lines="full" (click)="goToQuotes('/secure/quotes')">
              <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>Quotes</ion-label>
            </ion-item>
          }

          @if (permissionService.isPermitted('pos-orders')) {
            <ion-item button="true" lines="full" (click)="goToOrders('/secure/orders')">
              <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>Orders</ion-label>
            </ion-item>
          }

          @if (permissionService.isPermitted('pos-people')) {
            <ion-item button="true" lines="full" (click)="goToPeople('/secure/people')">
              <ion-label><fa-icon [icon]="['fal', 'user']" size="lg" [fixedWidth]="true"></fa-icon>People</ion-label>
            </ion-item>
          }

          @if (permissionService.isPermitted('pos-organisations')) {
            <ion-item button="true" lines="full" (click)="goToOrganisations('/secure/organisations')">
              <ion-label><fa-icon [icon]="['fal', 'building']" size="lg" [fixedWidth]="true"></fa-icon>Organisations</ion-label>
            </ion-item>
          }

          @if (permissionService.isPermitted('pos-reports')) {
            <ion-item lines="full" routerLink="/secure/reports" routerDirection="root" (click)="menuClose()">
              <ion-label><fa-icon [icon]="['fal', 'chart-column']" size="lg" [fixedWidth]="true"></fa-icon>Reports</ion-label>
            </ion-item>
          }

          @if (permissionService.isPermitted('pos-cash-tracking')) {
            <ion-item lines="full" routerLink="/secure/cash-tracking" routerDirection="root" (click)="menuClose()">
              <ion-label><fa-icon [icon]="['fal', 'search-dollar']" size="lg" [fixedWidth]="true"></fa-icon>Cash tracking</ion-label>
            </ion-item>
          }

          @if (permissionService.isPermitted('pos-settings')) {
            <ion-item lines="full" routerLink="/secure/settings" routerDirection="root" (click)="menuClose()">
              <ion-label><fa-icon [icon]="['fal', 'cog']" size="lg" [fixedWidth]="true"></fa-icon>Settings</ion-label>
            </ion-item>
          }

          @if (online) {
            <ion-item lines="full" button="true" (click)="presentChangePINModal()">
              <ion-label><fa-icon [icon]="['fal', 'key']" size="lg" [fixedWidth]="true"></fa-icon>Change PIN</ion-label>
            </ion-item>
          }

          <ion-item lines="full" button="true" (click)="reloadData()">
            <ion-label><fa-icon [icon]="['fal', 'arrows-rotate']" size="lg" [fixedWidth]="true"></fa-icon>Reload data</ion-label>
          </ion-item>

        </ion-list>
      </ion-list>

      <ion-list class="secondary-links">
        <ion-item button="true" lines="full" (click)="openWebsiteURL('https://support.airsquare.com')">
          <ion-label>Get help</ion-label>
          <fa-icon [icon]="['far', 'external-link-alt']" size="1x" [fixedWidth]="true" slot="end"></fa-icon>
        </ion-item>
        <ion-item button="true" lines="full" (click)="openWebsiteURL('https://www.airsquare.com/privacy-policy')">
          <ion-label>Privacy policy</ion-label>
          <fa-icon [icon]="['far', 'external-link-alt']" size="1x" [fixedWidth]="true" slot="end"></fa-icon>
        </ion-item>
        <ion-item button="true" lines="full" (click)="openWebsiteURL('https://www.airsquare.com/terms-of-service')">
          <ion-label>Terms of service</ion-label>
          <fa-icon [icon]="['far', 'external-link-alt']" size="1x" [fixedWidth]="true" slot="end"></fa-icon>
        </ion-item>
        <ion-item lines="full">
          <ion-label>Version</ion-label>
          {{version}}
        </ion-item>
      </ion-list>

    </ion-content>
    <ion-footer>
      <ion-list>
        <ion-item lines="none" routerLink="/switch-account" routerDirection="root" replaceUrl="true" (click)="menuClose()">
          <ion-label><fa-icon [icon]="['fal', 'sign-out-alt']" size="lg"></fa-icon>Logout / Switch user</ion-label>
        </ion-item>
      </ion-list>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="content" [swipeGesture]="false"></ion-router-outlet>
</ion-app>